import validate from "/usr/src/app/content/n3-redirections-legacy-af53cb62-ac8f-4f63-abef-2acc08fd29ac/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-legacy-af53cb62-ac8f-4f63-abef-2acc08fd29ac/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}